import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, DividerElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type DividerProps = RecursivePartial<DividerElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | DividerElement["children"];
  data?: DividerElement["data"];
};

export function Divider(props: DividerProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: DividerElement = {
    type: BasicType.DIVIDER,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
